import React, { useEffect, useState } from "react";
import "./role.scss";
import Table from "react-bootstrap/Table";
import { Link } from "react-router-dom";
import axios from "axios";
import AutoComplete from "rsuite/AutoComplete";
import ReactPaginate from "react-paginate";
import ModalUmum from "../../modal/modalUmum/ModalUmum";
import { BsSearch } from "react-icons/bs";

function Role() {
  const [data, setData] = useState([]);
  const [autoComplete, setAutoComplete] = useState([]);
  const [search, setsearch] = useState(false);
  const [deleteSuccess, setDeleteSuccess] = useState();
  const [currentItems, setCurrentItems] = useState([]);
  const [pageCount, setPageCount] = useState(0);
  const [itemOffset, setItemOffset] = useState(0);
  const [getSuccess, setGetSuccess] = useState(false);
  const [itemsPerPage, setitemsPerPage] = useState(10);
  const [modalShow, setModalShow] = useState(false);
  const [idRole, setIdRole] = useState();

  const getData = async () => {
    const result = await axios.get("https://mobile.amospa.com/roles");
    const role = result.data.data.map((value) => value.role);
    const category = result.data.data.map((value) => value.category);
    setAutoComplete(role.concat(category));
    setData(result.data.data);
    setGetSuccess(true);
  };

  // Invoke when user click to request another page.
  const handlePageClick = (event) => {
    const newOffset = (event.selected * itemsPerPage) % data.length;
    setItemOffset(newOffset);
  };

  useEffect(() => {
    getData();
    const endOffset = itemOffset + itemsPerPage;
    setCurrentItems(data.slice(itemOffset, endOffset));
    setPageCount(Math.ceil(data.length / itemsPerPage));
  }, [deleteSuccess, itemOffset, itemsPerPage, getSuccess]);

  //Handle search
  const keys = ["role", "category"];
  const handleSearch = () => {
    return search
      ? data.filter((item) => keys.some((key) => item[key].includes(search)))
      : false;
  };

  const role = handleSearch();
  const dataTable = role ? role : currentItems;

  //Handle Delete
  const deleteRole = async (id) => {
    setIdRole(id);
    setModalShow(true);
  };

  //Handle Next
  const handleNext = async () => {
    const result = await axios.delete(
      `https://mobile.amospa.com/roles/${idRole}`
    );
    setModalShow(false);
    setDeleteSuccess(result);
    window.location.reload();
  };

  return (
    <div className="role">
      <div className="header-cafe py-4">
        <span className="d-flex align-items-center">
          <h3 className="mx-2 text-white">List Role</h3>
          <p>
            <select onChange={(e) => setitemsPerPage(e.target.value)}>
              <option value="10">10</option>
              <option value="25">25</option>
              <option value="50">50</option>
              <option value="100">100</option>
            </select>
          </p>
        </span>
        <span className="d-flex">
          <Link to={"/homepage/setting/role/addrole"}>
            <button
              className="btn rounded-3 me-2 fw-bold"
              style={{ background: "#FFD700" }}
            >
              ADD ROLE
            </button>
          </Link>
          <span className="d-flex align-items-center list-search bg-light rounded-3 ps-1 me-2">
            <BsSearch color="black" fontSize="20px" />
            <AutoComplete
              placeholder="Search . . ."
              id="rs-input"
              onChange={(e) => setsearch(e)}
              data={autoComplete}
            />
          </span>
        </span>
      </div>
      <Table striped bordered hover>
        <thead>
          <tr>
            <th>NO</th>
            <th>Category</th>
            <th>Role</th>
            <th>Description</th>
            <th>List Menu</th>
            <th>Report Group</th>
            <th>Options</th>
          </tr>
        </thead>
        <tbody>
          {dataTable.map((item, index) => (
            <tr key={index}>
              <td>{index + 1}</td>
              <td>{item ? item.category : ""}</td>
              <td>{item ? item.role : ""}</td>
              <td>{item ? item.description : ""}</td>
              <td>{item ? item.menu : ""}</td>
              <td>{item ? item.report : ""}</td>
              <td className="d-flex">
                <Link to={`/homepage/edit-role/${item.id}`}>
                  <button
                    className="btn-staffid ms-2 bg-warning text-dark py-1 px-3"
                    style={{ borderRadius: "10px" }}
                  >
                    Edit
                  </button>
                </Link>
                <button
                  className="btn-staffid ms-2 px-2 py-1 bg-danger"
                  onClick={() => deleteRole(item.id)}
                  style={{ borderRadius: "10px" }}
                >
                  Delete
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </Table>
      <div className="footer-role mb-3">
        <p className="ms-2">
          Showing {currentItems.length} to {data.length} Entries
        </p>
        <div className="footer-role-rigth">
          <ReactPaginate
            breakLabel="..."
            nextLabel="next >"
            onPageChange={handlePageClick}
            pageRangeDisplayed={3}
            pageCount={pageCount}
            previousLabel="< previous"
            renderOnZeroPageCount={null}
            containerClassName="pagination"
            pageLinkClassName="page-num"
            previousLinkClassName="page-num"
            nextLinkClassName="page-num"
            activeLinkClassName="active"
          />
        </div>
      </div>
      <ModalUmum
        show={modalShow}
        onHide={() => setModalShow(false)}
        title="Success Delete Role"
        nextButton={handleNext}
      />
    </div>
  );
}

export default Role;
